exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".delete-modal-body {\n  width: 100%;\n  height: 25vh;\n  border-radius: 0;\n  font-size: 1.5em;\n  text-align: center;\n  white-space: normal;\n  word-break: break-word; }\n\n.modal-content-container {\n  width: 100%; }\n\n.modal-dialog {\n  width: 100%;\n  margin: 20em auto; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/css-loader!/root/social-native/socialnative-web/node_modules/postcss-loader/src??ref--4-2!/root/social-native/socialnative-web/node_modules/sass-loader/lib/loader.js!../scss/delete_warning.scss
// module id = 2014
// module chunks = 69